
import React, { Component } from "react";
import { Link } from "react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
  Spinner,
  Button,
  FormGroup, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import { AvForm, AvField } from "availity-reactstrap-validation";
import classnames from "classnames";
import Select from "react-select";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { BaseUrl } from "../../helpers/Baseurl";
import { isEmpty } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import { Dates, Months, months_name } from '../../helpers/methods'

import default_img from '../../assets/images/noimg.jpeg'

const customStyles = {
  overlay: {
      marginTop: '70px'
  }
}

class ActivityDetailPage extends Component {
  constructor(props) {
    super(props);
    this.obj = this.props.obj
    if (this.props.obj){
        if (!validateToken(this.props.obj.access)){
          this.props.history.push('/logout')
        }  
      }
    this.state = {
      isFits:false,
      images : [],
      images_name :[],
      photoIndex:0,
      activeTab: 1,
      activeDescriptionTab: "activity_detail",
      activity: {},
      pricing:[],
      pricing_id:"",
      alert_confirm : false,
      success_confirm : false,
      seasons:[],
      bank_detail:[],
      
      selectedStartMonth: { label: "Jan", value: 1 },
      selectedEndMonth: { label: "Jan", value: 1 },
      selectedStartDate: { label: "1", value: '1' },
      selectedEndDate: { label: "1", value: '1' },
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
    }

    this.toggleTab = this.toggleTab.bind(this);
    this.toggledescription = this.toggledescription.bind(this);
    this.handlePricingDelete = this.handlePricingDelete.bind(this)
    this.imageShow = this.imageShow.bind(this);
    this.tog_AddSeason = this.tog_AddSeason.bind(this);
    this.tog_EditSeason = this.tog_EditSeason.bind(this);
    this.tog_edit_bank_detail = this.tog_edit_bank_detail.bind(this)
    this.handleSeasonSubmit = this.handleSeasonSubmit.bind(this);
    this.handleEditSeasonSubmit = this.handleEditSeasonSubmit.bind(this);
    this.handleBankDetailSubmit = this.handleBankDetailSubmit.bind(this)

  }

  componentDidMount() { 
    this.loadData()
    if(this.obj){
        this.loadPaymentDetail()
    }
    
  }

  tog_AddSeason() {
    this.setState(prevState => ({
      model_AddSeason: !prevState.model_AddSeason
    }));
    this.removeBodyCss();
  }

  tog_EditSeason() {
    this.setState(prevState => ({
      model_EditSeason: !prevState.model_EditSeason
    }));
    this.removeBodyCss();
  }

  tog_edit_bank_detail() {
    this.setState(prevState => ({
        model_edit_bank_detail: !prevState.model_edit_bank_detail
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggledescription(tab) {
    if (this.state.activeDescriptionTab !== tab) {
      this.setState({
        activeDescriptionTab: tab,
      });
    }
  }

  imageShow(img, id) {
    const expandImg = document.getElementById("expandedImg" + id);
    expandImg.src = img;
  }

  onImageClick(images){
    let image = []
    let images_name = []
    for (let i=0; i<images.length; i++){
        image.push(BaseUrl+images[i].image)
        images_name.push(images[i].name)
    }
    this.setState({ isFits: true, photoIndex: 0, images:image, images_name})
  }

  async loadData(){
    const id =this.props.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/activities/activities/${id}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
              document.title = data.activity.name+" | Planmans"; 
              this.setState({ activity:data.activity,  pricing:data.pricing,seasons:data.seasons })      
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
   }

  async loadPaymentDetail(){
    const id =this.props.id
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
    };
    fetch(`${BaseUrl}/api/activities/activity-bank-detail/?activity__id=${id}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => { 
              this.setState({ bank_detail:data.results[0],  loading_bank_detail: false, model_edit_bank_detail:false })    
               
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        ) 
  }

  // Delete Selected Pricing 
  handlePricingDelete = id => { 
  const requestOptions = {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${this.obj.access}` },
  
      };
        fetch(`${BaseUrl}/api/activities/pricing/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                  }
                  else{
                    this.loadData();
                    this.setState({
                      pricing_id:"",
                      success_confirm: true,
                      alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Price has been deleted."
                      })
                  }
              }
          )
  }

  handleSelectedStartMonth = selectedStartMonth => {
    this.setState({ selectedStartMonth });
  }

  handleSelectedEndMonth = selectedEndMonth => {
    this.setState({ selectedEndMonth });
  }

  handleSelectedStartDate = selectedStartDate => {
    this.setState({ selectedStartDate });
  }

  handleSelectedEndDate = selectedEndDate => {
    this.setState({ selectedEndDate });
  }

   // Save Season Data  
  handleSeasonSubmit(){
    const {activity, selectedEndDate, selectedEndMonth, selectedStartDate, selectedStartMonth} = this.state
    this.setState({addSeasonloading:true})
    let data = {
      "start_date": selectedStartDate.value,
      "start_month": selectedStartMonth.value,
      "end_date": selectedEndDate.value,
      "end_month": selectedEndMonth.value,
      "activity": activity.id
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/activities/activity_seasons/`,requestOptions)
        .then(res => 
            {if(res.status >= 400){
              toastr.error("Something Went Wrong", "") 
              this.setState({ addSeasonloading: false })
            }
            else{
                this.loadData()
                this.setState({addSeasonloading: false, model_AddSeason:false })
            }    
        }
    )
  }

  // Delete Selected Season 
  handleSeasonDelete = id => {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${this.obj.access}` },
  
      };
        fetch(`${BaseUrl}/api/activities/activity_seasons/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                    toastr.error("Something Went Wrong", "") 
                    this.setState({
                      pricing_id:"",
                      season_success_confirm: false,
                      season_alert_confirm : false,
                      })
                  }
                  else{
                    this.loadData();
                    this.setState({
                      pricing_id:"",
                      season_success_confirm: true,
                      season_alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Season has been deleted."
                      })
                  }
              }
          )

  }

   // Save Bank Details
  handleBankDetailSubmit(e, values){
    const { bank_detail, activity } = this.state
    this.setState({ loading_bank_detail: true })
    let data = {  'bank_name': values.bank_name,
                  'ifsc':values.ifsc,
                  'account_no':values.account_no,
                  'upi':values.upi,
                  'account_name':values.account_name,
                  'branch_name':values.branch_name,
                  'upi_bank_name':values.upi_bank_name,
                  'upi_user_name':values.upi_user_name,
                  'activity': activity.id
                 }

    if(bank_detail){
      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/activities/activity-bank-detail/${bank_detail.id}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          console.log(data, "---data")
                          this.setState({ loading_bank_detail: false })
                        }
                          
                    )
                }
                else{
                  this.loadPaymentDetail()
                }    
            }
        )
    }else{
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/activities/activity-bank-detail/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          console.log(data, "---data")
                          this.setState({ loading_bank_detail: false })
                        }
                    )
                }
                else{
                  this.loadPaymentDetail()
                }    
            }
        )
    }


  }

  // Load Selected Season Data into Edit Modal 
  handleSeasonEdit = row => {
    let selectedEndDate = { label: row.end_date, value: row.end_date }
    let selectedEndMonth = { label: months_name[row.end_month-1], value: row.end_month }
    let selectedStartDate = { label: row.start_date, value: row.start_date }
    let selectedStartMonth = { label: months_name[row.start_month-1], value: row.start_month }
    this.setState({selectedEndDate, selectedEndMonth, selectedStartDate, selectedStartMonth, model_EditSeason:true, pricing_id:row.id  })

  }

  // Save Selected season Updated data 
  handleEditSeasonSubmit(){
    const {activity, selectedEndDate, selectedEndMonth, selectedStartDate, selectedStartMonth, pricing_id} = this.state
    this.setState({editSeasonloading:true})
    let data = {
      "start_date": selectedStartDate.value,
      "start_month": selectedStartMonth.value,
      "end_date": selectedEndDate.value,
      "end_month": selectedEndMonth.value,
      "activity": activity.id
    }
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/activities/activity_seasons/${pricing_id}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                    res.json()
                    .then(
                        (data) =>{  
                          toastr.error("Something Went Wrong", "") 
                          this.setState({ editSeasonloading: false, pricing_id:"" })
                        }     
                    )
                }
                else{
                  this.loadData()
                  this.setState({editSeasonloading: false, model_EditSeason:false, pricing_id:"" })
                }    
            }
        )
  }

  render() {
    const { activity, pricing, images, photoIndex, images_name, bank_detail } = this.state;
    let breadcrumbItems =  [
      { title: "Activities", link: "/activities" },
      { title: (activity.name? activity.name: "Activity")+" Detail", link: "#" },
    ]

    return (
      <React.Fragment>
        <div className={this.obj?"page-content":"mt-4"}>
          <Container fluid>
          {this.obj?
            <Breadcrumbs
              title={""}
              breadcrumbItems={breadcrumbItems}
            />:null}

            {!isEmpty(activity) ? (
              <React.Fragment>
                 {this.state.isFits ? (
                  <Lightbox
                            
                  reactModalStyle = {this.obj?customStyles:""}
                  mainSrc={images[photoIndex]}
                  nextSrc={images[(photoIndex + 1) % images.length]}
                  prevSrc={
                  images[(photoIndex + images.length - 1) % images.length]
                  }
                  enableZoom={false}
                  onCloseRequest={() => this.setState({ isFits: false })}
                  onMovePrevRequest={() =>
                  this.setState({
                      photoIndex: (photoIndex + images.length - 1) % images.length
                  })
                  }
                  onMoveNextRequest={() =>
                  this.setState({
                      photoIndex: (photoIndex + 1) % images.length
                  })
                  }
                  imageCaption={
                      `Image : ${images_name[photoIndex]}`
                      }
                />
                ) : null}
                <Row>
                  <Col lg={12}>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col xl="5">
                            <div className="activity-detail">
                              <Row>
                                <Col xs="3" className="scroll-y">
                                  <Nav className="flex-column" pills>
                                  {activity.image.map(
                                          (item, i) => ( 
                                            
                                    <NavItem>
                                      <NavLink
                                        className={classnames({
                                          active: this.state.activeTab === i+1,
                                        })}
                                        onClick={() => {
                                          this.toggleTab(i+1);
                                        }}
                                      >
                                        <img
                                          src={BaseUrl+item.image}
                                          alt={item.name}
                                          onClick={() => {
                                            this.imageShow(BaseUrl+item.image, i+1);
                                          }}
                                          className="img-fluid mx-auto d-block tab-img rounded"
                                        />
                                      </NavLink>
                                    </NavItem>
                                    ))}
                                  </Nav>
                                </Col>
                                <Col xs="9">
                                  <TabContent
                                    activeTab={this.state.activeTab}
                                    className="position-relative"
                                  >
                                     {activity.image.length > 0 ?
                                     activity.image.map(
                                        (item, i) => (  
                                          <TabPane tabId={i+1}>
                                            <div className="activity-img" style={{backgroundColor:"gray", height:"350px"}}>
                                              <img
                                                onClick= {() => this.onImageClick(activity.image)}
                                                src={BaseUrl+item.image}
                                                alt=""
                                                id={"expandedImg"+(i+1)}
                                                className="img-fluid mx-auto d-block"
                                                style={{ maxHeight:"350px", position: "absolute", top: "50%", left: "50%" ,transform: `translateX(-50%) translateY(-50%)`}}
                                              />
                                            </div>
                                          </TabPane>
                                    ))
                                    :
                                        <TabPane tabId={this.state.activeTab}>
                                          <div className="activity-img" style={{backgroundColor:"gray", height:"350px"}}>
                                            <img
                                              src={default_img}
                                              alt=""
                                              id={"expandedImg"+"default_img"}
                                              className="img-fluid mx-auto d-block"
                                              style={{ maxHeight:"350px", position: "absolute", top: "50%", left: "50%" ,transform: `translateX(-50%) translateY(-50%)`}}
                                            />
                                          </div>
                                        </TabPane>
                                    }
                                  </TabContent>
                                </Col>
                              </Row>
                            </div>
                          </Col>

                          <Col xl="7">
                            <div className="mt-4 mt-xl-3">
                              <h5 className="mt-1 mb-3">{activity.name}</h5>                              
                              <Row>
                                <Col md="12">
                                  <div>
                                    <h5 className="font-size-14">
                                      <i className="mdi mdi-location"></i>{" "}
                                      Description
                                    </h5>
                                    <p className="mt-3">{activity.description}</p>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                        <div className="mt-4">
                          <h5 className="font-size-14 mb-3">
                            Additional Details:{" "}
                          </h5>
                          <div className="activity-desc">
                            <Nav tabs className="nav-tabs-custom">
                                <NavItem>
                                    <NavLink
                                    className={classnames({
                                        active:
                                        this.state.activeDescriptionTab ===
                                        "activity_detail",
                                    })}
                                    onClick={() => {
                                        this.toggledescription("activity_detail");
                                    }}
                                    >
                                    Activity Detail
                                    </NavLink>
                                </NavItem>
                                {this.obj?<>
                                <NavItem>
                                    <NavLink
                                    className={classnames({
                                        active:
                                        this.state.activeDescriptionTab ===
                                        "pricing",
                                    })}
                                    onClick={() => {
                                        this.toggledescription("pricing");
                                    }}
                                    >
                                    Pricing
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                    className={classnames({
                                        active:
                                        this.state.activepricingTab ===
                                        "seasons",
                                    })}
                                    onClick={() => {
                                        this.toggledescription("seasons");
                                    }}
                                    >
                                    Seasons
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active:
                                        this.state.activepricingTab ===
                                        "payment",
                                    })}
                                    onClick={() => {
                                      this.toggledescription("payment");
                                    }}
                                  >
                                    Payment Detail
                                  </NavLink>
                                </NavItem>
                                </>:null}    
                            </Nav>
                            <TabContent
                              activeTab={this.state.activeDescriptionTab}
                              className="border border-top-0 p-4"
                            >
                              <TabPane tabId="activity_detail">
                                <div className="table-responsive">
                                    <Table className="table-nowrap mb-0">
                                      <tbody>
                                      <tr key={'name'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Name"}
                                          </th>
                                          <td>{activity.name}</td>
                                      </tr>
                                      <tr key={'activity'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Activity"}
                                          </th>
                                          <td>{activity.activity.name}</td>
                                      </tr>
                                      <tr key={'type'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Type"}
                                          </th>
                                          <td>{activity.activity_type}</td>
                                      </tr>
                                      {this.obj?<>
                                      <tr key={'contact_person'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Contact Person"}
                                          </th>
                                          <td>{activity.contact_person}</td>
                                      </tr>
                                      <tr key={'contact'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Contact Number"}
                                          </th>
                                          <td>{activity.contact}</td>
                                      </tr>
                                      <tr key={'agency'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Agency Name"}
                                          </th>
                                          <td>{activity.agency}</td>
                                      </tr>
                                      <tr key={'agency_contact'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Agency Contact Number"}
                                          </th>
                                          <td>{activity.agency_contact}</td>
                                      </tr>
                                      </>:null}
                                      <tr key={'address'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Address"}
                                          </th>
                                          <td>{activity.address}</td>
                                      </tr>
                                      <tr key={'zip_code'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"PinCode"}
                                          </th>
                                          <td>{activity.zip_code}</td>
                                      </tr>
                                      <tr key={'destination'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Destination"}
                                          </th>
                                          <td>{activity.destination.name}</td>
                                      </tr>
                                      
                                      <tr key={'Place'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Place"}
                                          </th>
                                          <td>{activity.place.name}</td>
                                      </tr>
                                      {activity.place.nearest_bus_station?
                                      <tr key={'nearest_bus_station'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Nearest Bus Station"}
                                            </th>
                                            <td>{activity.place.nearest_bus_station.name} ({activity.place.bus_station_distance} km)</td>
                                        </tr>:null}
                                        {activity.place.nearest_railway_station?
                                        <tr key={'nearest_railway_station'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Nearest Railway Station"}
                                            </th>
                                            <td>{activity.place.nearest_railway_station.name} ({activity.place.railway_distance} km)</td>
                                        </tr>:null}
                                        {activity.place.nearest_airport?
                                        <tr key={'nearest_airport'}>
                                            <th
                                            scope="row"
                                            style={{ width: "20%" }}
                                            >
                                            {"Nearest Airport Station"}
                                            </th>
                                            <td>{activity.place.nearest_airport.name} ({activity.place.airport_distance} km)</td>
                                        </tr>:null}
                                      </tbody>
                                    </Table>
                                  </div>
                                  {has_Permission(this.obj?.user, 4, 'edit' )?
                                  <Button type="button" className="btn-sm mt-4" onClick={() => this.props.history.push(`/edit-activity/${activity.id}`)} color="info"><i className="fas fa-pen"></i></Button>
                                :null}
                              </TabPane>
                              <TabPane tabId="pricing">
                                <div className="table-responsive">
                                  <Table className="table-nowrap mb-0">
                                    <tbody>
                                    <tr key={'PricingHeading'}>
                                          <th
                                          scope="row"
                                          >
                                          {"Distance"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"Time Duration"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"Group"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"Off Season Price"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"On Season Price"}
                                          </th>
                                          {has_Permission(this.obj?.user, 4, 'edit' ) || has_Permission(this.obj?.user, 4, 'delete' )?
                                          <th
                                          scope="row"
                                          >
                                          {"Action"}
                                          </th>
                                          :null}
                                      </tr>
                                      {pricing.map(
                                          (item, index) => (
                                            
                                                  <tr key={index}>

                                                      <td>{item.distance} km</td>
                                                      <td>{item.duration} Hours</td>
                                                      <td>
                                                      {item.group_pricing.map(
                                                      (group, i) => (
                                                        <tr key={"group"+i} className="mt-3">
                                                            <td className="mt-4">
                                                              {group.group.max_person ===1?`Per Person`:`${group.group.min_person} - ${group.group.max_person} Person`}
                                                              </td>
                                                        </tr>
                                                        
                                                      ))}
                                                      </td>
                                                      <td>
                                                      {item.group_pricing.map(
                                                      (group, i) => (
                                                        
                                                        <tr key={"group"+i}>
                                                            <td>₹ {group.price}</td>
                                                        </tr>
                                                      ))}
                                                      </td>
                                                      <td>
                                                      {item.group_pricing.map(
                                                      (group, i) => (
                                                        
                                                        <tr key={"group1"+i}>
                                                            <td>₹ {group.on_season_price}</td>
                                                        </tr>
                                                      ))}
                                                      </td>
                                                      <td>
                                                      {has_Permission(this.obj?.user, 4, 'edit' )?
                                                        <Link to="#" onClick={() =>this.props.history.push(`/edit-activity-pricing/${item.id}`)}  className="text-primary"><i className="mdi mdi-pencil-outline font-size-18"></i></Link>
                                                      :null}{" "}
                                                      {has_Permission(this.obj?.user, 4, 'delete' )?
                                                      <Link to="#" onClick={() => this.setState({ alert_confirm: true, pricing_id:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                                      :null}
                                                      </td>
                                                  </tr>
                                                    
                                                ))}
                                    </tbody>
                                  </Table>
                                </div>
                                {has_Permission(this.obj?.user, 4, 'edit' )?
                                <Button type="button" className="btn-sm mt-4" onClick={() => this.props.history.push(`/activity-pricing/${activity.id}`)} color="info"><i className=" fas fa-plus"></i></Button>
                                :null}
                              </TabPane>
                              <TabPane tabId="seasons">
                                  <div className="table-responsive">
                                    <Table className="table-nowrap mb-0">
                                      <tbody>
                                      <tr key={'SeasonsHeading'}>
                                          <th
                                          scope="row"
                                          >
                                          {"Srart"}
                                          </th>
                                          <th
                                          scope="row"
                                          >
                                          {"End"}
                                          </th>
                                          {has_Permission(this.obj?.user, 4, 'edit' )|| has_Permission(this.obj?.user, 4, 'delete' )?
                                          <th
                                          scope="row"
                                          >
                                          {"Action"}
                                          </th>
                                          :null}
                                      </tr>
                                      {this.state.seasons.map(
                                          (item, i) => (
                                      <tr key={"season"+i}>
                                          <td>{item.start_date} {months_name[item.start_month-1]}</td>
                                          <td>{item.end_date} {months_name[item.end_month-1]}</td>
                                          <td>
                                          {has_Permission(this.obj?.user, 4, 'edit' )?
                                          <Link to="#" onClick={() => this.handleSeasonEdit(item)}  className="text-primary"><i className="mdi mdi-pencil-outline font-size-18"></i></Link>
                                          :null}{" "}
                                          {has_Permission(this.obj?.user, 4, 'delete' )?
                                          <Link to="#" onClick={() => this.setState({ season_alert_confirm: true, pricing_id:item.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
                                          :null}
                                          </td>
                                      </tr>
                                          ))}
                                    

                                      </tbody>
                                    </Table>
                                  </div>
                                  {has_Permission(this.obj?.user, 4, 'edit' )?
                                  <Button type="button" className="btn-sm mt-4" onClick={this.tog_AddSeason} color="info"><i className=" fas fa-plus"></i></Button>
                                  :null}
                              </TabPane>
                              <TabPane tabId="payment">
                                <div className="table-responsive">
                                    <Table className="table-nowrap mb-0">
                                      <tbody>
                                      <tr key={'acc_name'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Account Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.account_name:""}</td>
                                      </tr>
                                      <tr key={'acc_number'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Account Number"}
                                          </th>
                                          <td>{bank_detail?bank_detail.account_no:""}</td>
                                      </tr>
                                      <tr key={'bank_n'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Bank Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.bank_name:""}</td>
                                      </tr>
                                      <tr key={'bank_branch'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"Branch"}
                                          </th>
                                          <td>{bank_detail?bank_detail.branch_name:""}</td>
                                      </tr>
                                      <tr key={'acc_ifsc'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"IFSC code"}
                                          </th>
                                          <td>{bank_detail?bank_detail.ifsc:""}</td>
                                      </tr>
                                      <tr key={'upi_bank_n'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI Bank Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi_bank_name:""}</td>
                                      </tr>
                                      <tr key={'upi_user_n'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI User Name"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi_user_name:""}</td>
                                        </tr>
                                      <tr key={'acc_upi'}>
                                          <th
                                          scope="row"
                                          style={{ width: "20%" }}
                                          >
                                          {"UPI"}
                                          </th>
                                          <td>{bank_detail?bank_detail.upi:""}</td>
                                      </tr>
                                      
                                      </tbody>
                                    </Table>
                                </div>
                                {has_Permission(this.obj?.user, 4, 'edit' )?
                                <Button type="button" className="btn-sm mt-4" onClick={this.tog_edit_bank_detail} color="info"><i className="fas fa-pen"></i></Button>
                                :null}
                                </TabPane>
                            </TabContent>
                          </div>
                        </div>

                        {/* <Reviews comments={activity.comments} /> */}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </React.Fragment>
            ):
            <div className="d-flex align-items-center justify-content-center min-vh-100">
            
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
              <Spinner type="grow" className="me-2" color="secondary" />
      
            </div>
                  }
          </Container>
        </div>
        {/* Add Season */}
        <Col sm={6} md={4} xl={3} className="mt-4">
              
              <Modal
                isOpen={this.state.model_AddSeason}
                toggle={() => this.tog_AddSeason()}
                centered={true}
              >
                <ModalHeader toggle={() => this.setState({ model_AddSeason: false })}>
                Add Season 
                </ModalHeader>
                <ModalBody>
                  <AvForm className="needs-validation" onValidSubmit={this.handleSeasonSubmit} >
                  <Row> 
                    <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Start Date</Label>
                              <Select 
                              value={this.state.selectedStartDate}
                              onChange={this.handleSelectedStartDate}
                              options={Dates}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">Start Month</Label>
                              <Select 
                              value={this.state.selectedStartMonth}
                              onChange={this.handleSelectedStartMonth}
                              options={Months}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col>
                    </Row>  
                    <Row> 
                    <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">End Date</Label>
                              <Select 
                              value={this.state.selectedEndDate}
                              onChange={this.handleSelectedEndDate}
                              options={Dates}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                              <Label className="form-label">End Month</Label>
                              <Select 
                              value={this.state.selectedEndMonth}
                              onChange={this.handleSelectedEndMonth}
                              options={Months}
                              classNamePrefix="select2-selection"
                              />

                          </div>
                      </Col>
                    </Row>  
                 
          
                                      
                    <FormGroup className="mb-0">
                      {this.state.addSeasonloading?(
                        <Spinner className="me-2 mt-2" color="primary" />
                      ):(
                        <div>
                    
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                      </div>
                        )}
                    </FormGroup>     
                  </AvForm>

                </ModalBody>
              </Modal>
        </Col>
        {/* Edit Season */}
        <Col sm={6} md={4} xl={3} className="mt-4">
          
          <Modal
            isOpen={this.state.model_EditSeason}
            toggle={() => {this.tog_EditSeason(); this.setState({ pricing_id:""})}}
            centered={true}
          >
            <ModalHeader toggle={() => {this.tog_EditSeason(); this.setState({ pricing_id:""})}}>
            Edit Season 
            </ModalHeader>
            <ModalBody>
              <AvForm className="needs-validation" onValidSubmit={this.handleEditSeasonSubmit} >
              <Row> 
              

                <Col md="6">
                      <div className="mb-3">
                          <Label className="form-label">Start Date</Label>
                          <Select 
                          value={this.state.selectedStartDate}
                          onChange={this.handleSelectedStartDate}
                          options={Dates}
                          classNamePrefix="select2-selection"
                          />

                      </div>
                  </Col> 
                  <Col md="6">
                      <div className="mb-3">
                          <Label className="form-label">Start Month</Label>
                          <Select 
                          value={this.state.selectedStartMonth}
                          onChange={this.handleSelectedStartMonth}
                          options={Months}
                          classNamePrefix="select2-selection"
                          />

                      </div>
                  </Col>
                </Row>  
                <Row> 
                <Col md="6">
                      <div className="mb-3">
                          <Label className="form-label">End Date</Label>
                          <Select 
                          value={this.state.selectedEndDate}
                          onChange={this.handleSelectedEndDate}
                          options={Dates}
                          classNamePrefix="select2-selection"
                          />

                      </div>
                  </Col> 
                  <Col md="6">
                      <div className="mb-3">
                          <Label className="form-label">End Month</Label>
                          <Select 
                          value={this.state.selectedEndMonth}
                          onChange={this.handleSelectedEndMonth}
                          options={Months}
                          classNamePrefix="select2-selection"
                          />

                      </div>
                  </Col>
                </Row>  
              
      
                                  
                <FormGroup className="mb-0">
                  {this.state.editSeasonloading?(
                    <Spinner className="me-2 mt-2" color="primary" />
                  ):(
                    <div>
                
                  <Button type="submit" color="primary" className="me-1">
                    Submit
                  </Button>
                  </div>
                    )}
                </FormGroup>     
              </AvForm>

            </ModalBody>
          </Modal>
        </Col>
        {/* Add/Edit Bank Detail  */}
        <Col sm={6} md={4} xl={3} className="mt-4">    
            <Modal
              isOpen={this.state.model_edit_bank_detail}
              toggle={this.tog_edit_bank_detail}
              centered={true}
            >
              <ModalHeader toggle={this.tog_edit_bank_detail}>
              {bank_detail?"Edit ": "Add "}Payment Detail
              </ModalHeader>
              <ModalBody>
                <AvForm className="needs-validation" onValidSubmit={this.handleBankDetailSubmit} >
                  <h6 className="mb-4">Bank Details </h6>
                  <Row>
                      <Col md="6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="account_name">Account Name</Label>
                            <AvField
                                name="account_name"
                                type="text"
                                placeholder="Account Name"
                                errorMessage="Enter Account Name"
                                className="form-control"
                                value= {bank_detail?.account_name}
                                validate={{ required: { value: true } }}
                                id="account_name"
                                
                            />
                          </div>
                        </Col> 
                        <Col md={6}>
                            <div className="mb-3">
                                <AvField
                                    name="account_no"
                                    label="Account Number"
                                    placeholder="Account Number"
                                    type="number"
                                    value= {bank_detail?.account_no}
                                    errorMessage="Enter Only Digits"
                                    validate={{
                                        required: { value: true },
                                        pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Digits"
                                        }
                                    }}
                                    />
                            </div>
                        </Col>
                          
                  </Row>   
                  <Row>
                      <Col md="6">
                          <div className="mb-3">
                          <Label className="form-label " htmlFor="bank_name">Bank Name</Label>
                          <AvField
                              name="bank_name"
                              placeholder="Bank Name"
                              type="text"
                              errorMessage="Enter Bank Name"
                              className="form-control"
                              value= {bank_detail?.bank_name}
                              validate={{ required: { value: true } }}
                              id="bank_name"
                              
                          />
                          </div>
                      </Col> 
                      <Col md="6">
                          <div className="mb-3">
                          <Label className="form-label " htmlFor="branch_name">Branch Name</Label>
                          <AvField
                              name="branch_name"
                              type="text"
                              placeholder="Branch Name"
                              errorMessage="Enter Branch Name"
                              className="form-control"
                              value= {bank_detail?.branch_name}
                              validate={{ required: { value: true } }}
                              id="branch_name"
                              
                          />
                          </div>
                      </Col> 
                      
                  </Row>
                  <Row>
                      <Col md="6">
                          <div className="mb-3">
                          <Label className="form-label " htmlFor="ifsc">IFSC Code</Label>
                          <AvField
                              name="ifsc"
                              type="text"
                              placeholder="IFSC Code"
                              errorMessage="Enter IFSC Code"
                              value= {bank_detail?.ifsc}
                              className="form-control"
                              validate={{ required: { value: true } }}
                              id="ifsc"  
                          />
                          </div>
                      </Col> 
                  </Row>
                  <hr />
                  <h6 className="mb-4">UPI Details </h6>
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label className="form-label " htmlFor="upi_user_name">User Name</Label>
                        <AvField
                          name="upi_user_name"
                          placeholder="User Name"
                          type="text"
                          errorMessage="Enter User Name"
                          className="form-control"
                          value= {bank_detail?.upi_user_name}
                          validate={{ required: { value: true } }}
                          id="upi_user_name"
                            
                        />
                      </div>
                    </Col> 
                    <Col md="6">
                        <div className="mb-3">
                        <Label className="form-label " htmlFor="upi_bank_name">Bank Name</Label>
                        <AvField
                            name="upi_bank_name"
                            placeholder="UPI Bank Name"
                            type="text"
                            errorMessage="Enter Bank Name"
                            className="form-control"
                            value= {bank_detail?.upi_bank_name}
                            validate={{ required: { value: true } }}
                            id="upi_bank_name"
                        />
                        </div>
                    </Col> 
                  </Row>
                  <Row>
                  <Col md="6">
                      <div className="mb-3">
                      <Label className="form-label " htmlFor="upi">UPI ID</Label>
                      <AvField
                          name="upi"
                          type="text"
                          placeholder="UPI"
                          errorMessage="Enter UPI"
                          className="form-control"
                          value= {bank_detail?.upi}
                          validate={{ required: { value: true } }}
                          id="upi"
                      />
                      </div>
                    </Col> 
                  </Row>               
                  <FormGroup className="mb-0">
                    {this.state.loading_bank_detail?(
                      <Spinner className="me-2 mt-2" color="primary" />
                    ):(
                      <div>
                  
                    <Button type="submit" color="primary" className="me-1">
                      Submit
                    </Button>
                    </div>
                      )}
                  </FormGroup>     
                </AvForm>
              </ModalBody>
            </Modal>
        </Col>

        {/* Delete Model  */}
        {this.state.alert_confirm ? (
                <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.handlePricingDelete(this.state.pricing_id)}
                onCancel={() =>
                    this.setState({
                        alert_confirm: false,
                        pricing_id:"",

                    })
                }
                >
                You won't be able to revert this!
                </SweetAlert>
            ) : null}

            {this.state.success_confirm ? (
                <SweetAlert
                success
                title={this.state.dynamic_title}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                >
                  {this.state.dynamic_description}
                </SweetAlert>
            ) : null}
            {this.state.season_alert_confirm ? (
              <SweetAlert
              title="Are you sure?"
              warning
              showCancel
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => this.handleSeasonDelete(this.state.pricing_id)}
              onCancel={() =>
                  this.setState({
                    season_alert_confirm: false,
                      pricing_id:"",

                  })
              }
              >
              You won't be able to revert this!
              </SweetAlert>
          ) : null}

          {this.state.season_success_confirm ? (
              <SweetAlert
              success
              title={this.state.dynamic_title}
              confirmBtnBsStyle="success"
              cancelBtnBsStyle="danger"
              onConfirm={() => this.setState({ season_success_confirm: false, season_alert_confirm : false,  })}
              >
                  {this.state.dynamic_description}
              </SweetAlert>
          ) : null}
            {/*  */}
      </React.Fragment>
    );
  }
}


export default ActivityDetailPage ;
